"use client";
import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import { stringToSlug } from "@/utils/slug";
import { Dot, MoveRight } from "lucide-react";
import clsx from "clsx";
import { documentHasH2 } from "@/utils/contentHash2";

interface RichTextProps {
  richTextDocument: any; // Typiquement un JSON venant de Contentful
}

export const PostSummary: React.FC<RichTextProps> = ({ richTextDocument }) => {
  // console.log("links", links);

  const options = {
    renderNode: {
      [BLOCKS.HEADING_2]: (node: any, children: any) => (
        <div className="group">
          <div className="flex space-x-6 justify-start">
            <div className="flex items-center space-x-0 group-hover:translate-x-2 transition-transform duration-75 ease-in-out">
              <Dot className="text-brand-red" />
              <MoveRight size={28} strokeWidth={1.3} />
            </div>
            <button
              className="text-brand-blue hover:underline hover:text-black text-left line-clamp-2"
              onClick={() => {
                const element = document.getElementById(
                  stringToSlug(children[0])
                );
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              {children}
            </button>
          </div>
        </div>
      ),
      [BLOCKS.HEADING_3]: () => null,
      [BLOCKS.HEADING_4]: () => null,
      [BLOCKS.HEADING_5]: () => null,
      [BLOCKS.PARAGRAPH]: () => null,
    },
  };

  return (
    <div
      className={clsx(
        "space-y-6 pb-6",
        documentHasH2(richTextDocument) ? "block" : "hidden"
      )}
    >
      <p className="font-semibold text-xl">Sommaire de le page</p>
      <div className="flex">
        <div className="h-1 w-10 bg-brand-red " />
      </div>
      <div className="space-y-4">
        {documentToReactComponents(richTextDocument, options)}
      </div>
    </div>
  );
};
